module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/confirm-account-mobile-d6aec226f17b0fccfe14acd53ad24441.jpeg";